import { useEffect, useState } from "react";
import { mergeDefault } from "@/components/radar/utils/filterBubbles";
import { adminApi } from "@/services/api/admin";
import {
  teacherApi,
  type RadarConfigResponse,
  type RadarFilterState,
} from "@/services/api/teacher";

export function useTalkRadarFilterConfig(role: "admin" | "teacher") {
  const [configLock, setConfigLock] = useState(false);
  const [lockedFilterSnapshot, setLockedFilterSnapshot] =
    useState<RadarFilterState | null>(null);
  const [configMin, setConfigMin] = useState<number | null>(null);
  const [configMax, setConfigMax] = useState<number | null>(null);
  const [incomingOff, setIncomingOff] = useState(false);
  const [configReady, setConfigReady] = useState(
    () =>
      typeof (role === "admin" ? adminApi : teacherApi).getRadarConfig !==
      "function"
  );

  useEffect(() => {
    let live = true;
    const api = role === "admin" ? adminApi : teacherApi;
    if (typeof api.getRadarConfig !== "function") {
      setConfigReady(true);
      return;
    }
    Promise.resolve(api.getRadarConfig())
      .then((cfg: RadarConfigResponse | null | undefined) => {
        if (!live || !cfg) return;
        if (typeof cfg.min_time_range_days === "number")
          setConfigMin(cfg.min_time_range_days);
        if (typeof cfg.max_time_range_days === "number")
          setConfigMax(cfg.max_time_range_days);
        if (role === "teacher" && cfg.show_incoming_in_radar === false)
          setIncomingOff(true);
        if (
          role === "teacher" &&
          cfg.radar_filter_allow_teacher_override === false
        ) {
          setLockedFilterSnapshot(
            mergeDefault(cfg.radar_filter_default_state, "teacher")
          );
          setConfigLock(true);
        }
      })
      .catch(() => {})
      .finally(() => {
        if (live) setConfigReady(true);
      });
    return () => {
      live = false;
    };
  }, [role]);

  return {
    configLock,
    lockedFilterSnapshot,
    configMin,
    configMax,
    incomingOff,
    configReady,
  };
}
